/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'window',
  'react',
  'react-dom',
  'pip-model',
  'cookie-utils',
  'pip-trackif',
  'pip-cart',
  'pip-instant_checkout'
],
function (
  $,
  Mustache,
  window,
  React,
  ReactDOM,
  pip,
  cookieUtils,
  pipTrackif,
  pipCart,
  pipInstantCheckout
) {

var buyBeltView;

function isBuyBeltReactEnabled(){
  var isEnabled = false;
  try{
    if ((pip && pip.features && pip.features.reactFulfillmentTilesEnabled) ||
    (cookieUtils.readCookie('pipBuyBeltReact'))) {
      isEnabled = true;
    }
  }catch(e){
    isEnabled = false;
  }
  return isEnabled;
}


function initializeReact() {
  try {
    ReactDOM.render(
        React.createElement(BuyBeltNew, 
          {
            pipModel: pip, 
            pipHooks: {
              Mustache: Mustache,
              pipTrackif: pipTrackif,
              pipCart: pipCart,
              view: buyBeltView,
              pipInstantCheckout: pipInstantCheckout
            }
          }),
        document.querySelector('#buybelt-wrapper-new')
    );
  } catch (e) {
    if (pip.debugMode) { console.error(e); }
  }
}

function getUrl(artifactName) {
  var devOverrideVersion = cookieUtils.readCookie('pipBuyBeltReactVersion');
  var fsVersion = (pip && pip.features && pip.features.reactFulfillmentTilesVersion) ? pip.features.reactFulfillmentTilesVersion : '';
  var version = devOverrideVersion || fsVersion;
  var path = '/react-components/buybelt/' + version + '/' + artifactName;
  return ('https://assets.homedepot-static.com' + path);
}

function loadCss(){
  var url = getUrl('main.css');
  var link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('type', 'text/css');
  link.setAttribute('href', url);
  document.getElementsByTagName('head')[0].appendChild(link);
}

function loadScript() {
  var url = getUrl('main.js');
  var script = document.createElement('script');
  var firstScriptOnPage = document.getElementsByTagName('script')[0];
  script.type = 'text/javascript';
  firstScriptOnPage.parentNode.insertBefore(script, firstScriptOnPage);
  script.onreadystatechange = initializeReact;
  script.onload = initializeReact;
  script.src = url;
}

return {
  prepLayout: function() {
    try{
      if(isBuyBeltReactEnabled()){
        var buyBox = document.querySelector('.buybox');
        var buyBoxNew = document.querySelector('#buybelt-wrapper-new');
        if(!buyBoxNew){
          var buyBeltWrapper = document.createElement( 'div' );
          buyBeltWrapper.id = 'buybelt-wrapper-new';
          buyBox.appendChild( buyBeltWrapper );
        }
      }
    }catch(e){
      if (pip.debugMode) { console.error(e); }
    }
  },
  init: function (view) {
    if(isBuyBeltReactEnabled()){
      buyBeltView = view;
      if(typeof BuyBeltNew !== 'undefined'){
        initializeReact();
      }else{
        loadCss();
        loadScript();
      }
    }
  },
  isEnabled: isBuyBeltReactEnabled
}
});

}.call(window));